// extracted by mini-css-extract-plugin
export default {"slidingPanel":"SlidingPanel_slidingPanel__2WTA5","isVisibleSlidingPanel":"SlidingPanel_isVisibleSlidingPanel__o9XvU","content":"SlidingPanel_content__DjCPu"};